import { render, staticRenderFns } from "./CheckCircle.vue?vue&type=template&id=2b139855"
import script from "./CheckCircle.vue?vue&type=script&lang=js"
export * from "./CheckCircle.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports